export default "__VITE_ASSET__6651616d__"